'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002431 from "./presto.-Two-Factor-Auth-View$$anon$31.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002433 from "./presto.-Two-Factor-Auth-View$$anon$33.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002435 from "./presto.-Two-Factor-Auth-View$$anon$35.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002437 from "./presto.-Two-Factor-Auth-View$$anon$37.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024 from "./presto.types$-Two-Factor-Auth-Usage$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$30(outer) {
  this.bCG = null;
  this.bCy = null;
  this.bCz = false;
  this.bCH = null;
  this.bCI = false;
  this.bCL = null;
  this.bCE = null;
  this.bCF = false;
  this.bCA = null;
  this.bCB = false;
  this.bCC = null;
  this.bCD = false;
  this.bCJ = false;
  this.bCK = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bCG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bCL = "TwoFactorAuthUsage";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$30 as $c_Lpresto_TwoFactorAuthView$$anon$30 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$30.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$30;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$30() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$30 as $h_Lpresto_TwoFactorAuthView$$anon$30 };
$h_Lpresto_TwoFactorAuthView$$anon$30.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bCG;
});
$p.M = (function() {
  if ((!this.bCz)) {
    this.bCy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bCz = true;
  }
  return this.bCy;
});
$p.O = (function() {
  if ((!this.bCI)) {
    this.bCH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bCI = true;
  }
  return this.bCH;
});
$p.D = (function() {
  return this.bCL;
});
$p.t = (function() {
  if ((!this.bCF)) {
    this.bCE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credentials", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bCF = true;
  }
  return this.bCE;
});
$p.N = (function() {
  if ((!this.bCB)) {
    this.bCA = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002431.$c_Lpresto_TwoFactorAuthView$$anon$31(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002433.$c_Lpresto_TwoFactorAuthView$$anon$33())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002435.$c_Lpresto_TwoFactorAuthView$$anon$35())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bCB = true;
  }
  return this.bCA;
});
$p.Q = (function() {
  if ((!this.bCD)) {
    this.bCC = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002437.$c_Lpresto_TwoFactorAuthView$$anon$37();
    this.bCD = true;
  }
  return this.bCC;
});
$p.v = (function() {
  if ((!this.bCK)) {
    this.bCJ = false;
    this.bCK = true;
  }
  return this.bCJ;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee324) => ((p) => \u03b4scrutinee324.zl(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024.$m_Lpresto_types$TwoFactorAuthUsage$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$30 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$30, "presto.TwoFactorAuthView$$anon$30", ({
  SA: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$30 as $d_Lpresto_TwoFactorAuthView$$anon$30 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$30.js.map
